import React, { useState } from "react";
import axios from "axios";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Spinner,
  Text,
  Select,
  SimpleGrid
} from "@chakra-ui/react";
import { constants } from "constants/constants";
import ItemTable from "./components/ItemTable";

function Claims() {
  const [trackingNumber, setTrackingNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [responseData, setResponseData] = useState(null);
  const [claimType, setClaimType] = useState("");

  const LostForm = ({ orderItems }) => {
  
    return (
      <ItemTable orderItems={orderItems} />
    );
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    const token = localStorage.getItem("accessToken");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    // Call the API with the provided order number
    axios
      .get(`${constants.apiUrl}/customer/get-claims`, { headers, withCredentials: true, params: { trackingNumber: trackingNumber } })
      .then((response) => {
        const responseData = response.data;
        const despatchDate = responseData.DespatchDate;
        const formattedDespatchDate = new Date(despatchDate).toLocaleString();
        
        responseData.DespatchDate = formattedDespatchDate; // Update the formatted date in the response data
        
        setResponseData(responseData);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching claims:", error);
        setIsLoading(false);
        setResponseData(null);
      });
  };

  return (
    <Box p={6}>
      <Heading mb={4} size="lg">
        Create Claim
      </Heading>
      <Flex direction={{ base: "column", md: "row" }} gridGap="20px">

        <FormControl mt={4}>
          <FormLabel>Enter Tracking Number</FormLabel>

        </FormControl>
        <FormControl mt={4}>
          <Input
            type="text"
            value={trackingNumber}
            onChange={(e) => setTrackingNumber(e.target.value)}
            required
            variant="brand"
          />
        </FormControl>
        {/* Add more dropdowns as needed for warehouse, department, client, task type, and billing type */}
        <FormControl mt={4}>
          <Button colorScheme="green" size='md' onClick={handleFormSubmit}>
            Report Lost/Damaged
          </Button>

        </FormControl>

      </Flex>
      {isLoading ? (
        <Flex mt={8} alignItems="center" justifyContent="center">
          <Spinner size="xl" color="green.500" />
        </Flex>
      ) : responseData ? (
        <Box p={6} mt={8} backgroundColor={"white"} >
          <SimpleGrid columns={4} spacing={4}>
            <Box>
              <Text fontWeight="bold" mr={2}>
                Carrier:
              </Text>
              <Text>{responseData.CourierServiceName}</Text>
            </Box>
            <Box>
              <Text fontWeight="bold" mr={2}>
                Order number:
              </Text>
              <Text>{responseData.OrderNumber}</Text>
            </Box>
            <Box>
              <Text fontWeight="bold" mr={2}>
                Despatch Date:
              </Text>
              <Text>{responseData.DespatchDate}</Text>
            </Box>
            <Box>
              <Text fontWeight="bold" mr={2}>
                Claim type:
              </Text>
              <Select
                value={claimType}
                onChange={(e) => setClaimType(e.target.value)}
                placeholder="Select claim type"
              >
                <option value="lost">Lost</option>
                <option value="damage">Damage</option>
                <option value="late">Late</option>
              </Select>
            </Box>
          </SimpleGrid>

        </Box>
      ) : null}

      {/* Conditionally render the appropriate claim type form */}
      {claimType === "lost" && !isLoading && <LostForm orderItems={responseData?.OrderItems || []} />}
    </Box>

  );



}

export default Claims;
